import { v4 as uuid } from 'uuid';
import { isElectron } from '../utils/electron';
import { runElectronCommand } from './videoElectronCommands';

let worker: Worker | null = null;
let workerMessageHandlers: ((e: MessageEvent) => void)[] = [];


let callbacks:Record<string,(val:any)=>void>={};

export const initWorker = () => {
  if (!worker && !isElectron()) { //we need worker for web only
    worker = new Worker(new URL('./videoWorker.ts', import.meta.url), { type: 'module' });
    worker.onmessage = (e: MessageEvent) => {
      if (callbacks[e.data.id]) {
        callbacks[e.data.id](e.data);
        delete callbacks[e.data.id];
      }
      for (const handler of workerMessageHandlers) {
        handler(e);
      }
    };

    worker.onerror = (err: ErrorEvent) => {
      console.error("Worker error:", err);
    };
    //console.log("worker created")
  }
};

export const terminateWorker = () => {
  if (worker) {
    worker.terminate();
    worker = null;
  }
  workerMessageHandlers = [];
};

export const registerWorkerMessageHandler = (handler: (e: MessageEvent) => void) => {
  workerMessageHandlers.push(handler);
};

export const unregisterWorkerMessageHandler = (handler: (e: MessageEvent) => void) => {
  workerMessageHandlers = workerMessageHandlers.filter(h => h !== handler);
};


export const postWorkerMessage = (message:any) => {
  if (worker) {
    worker.postMessage(message);
  }
};

export const runInWorker = (message:any,callback: (val:any)=>void) => {
    const id=uuid();
    if (isElectron()) {
        runElectronCommand({...message, callback, id})
    } else if (worker) {
        callbacks[id]=callback;
        worker.postMessage({...message,id});
    }
}